export default {
  props: {
    id_prodotto: String,
    id_colore: String,
    colori_disponibili: Array,
    colore: Object
  },
  data() {
    return {
      loading: true,
      // colore: null,
    };
  },
  // mounted() {
  //   this.$store.dispatch("fetch_colore_by_id", this.id_colore).then((res) => {
  //     this.colore = res;
  //     this.loading = false;
  //   });
  // },
  computed: {
    colore_url() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie" +
        "/img_colore/" +
        this.colore.id
      );
    },
    disponibile() {
      if (!this.colori_disponibili) {
        return false;
      } else {
        return this.colori_disponibili.includes(this.colore.id);
      }
    },
  },
  methods: {
    toggle_disponibile() {
      this.$store
        .dispatch("imposta_colore_specie_disponibile", {
          id_prodotto: this.id_prodotto,
          id_colore: this.colore.id,
          disponibile: !this.disponibile,
        })
        .then(() => {
          if (this.colori_disponibili.length === 0) {
            this.$store.dispatch("cambia_disponibile", {
              id: this.id_prodotto,
              stato: false,
            });
          }
        });
    },
  },
};
